module.exports = __webpack_public_path__ + "static/media/bootstrap.5f2a9141.svg";